/**
 * Which name to show for a menu item or an order line.
 *
 * The English name is required and the Nepali one is not, so Nepali is used
 * only when it has actually been filled in. That keeps a half-filled menu
 * readable instead of blanking out every item that has no Devanagari name yet.
 */

/** Display name for a menu item (has `name` / `nameNepali`). */
export function itemLabel(item, language) {
  if (!item) return '';
  if (language === 'ne' && item.nameNepali) return item.nameNepali;
  return item.name || '';
}

/**
 * Display name for an order line. Orders snapshot the name at the moment they
 * are rung up, so they carry `itemName` / `itemNameNepali` rather than the live
 * item. Older lines predate the snapshot and only have the English one.
 */
export function orderLabel(order, language) {
  if (!order) return '';
  if (language === 'ne' && order.itemNameNepali) return order.itemNameNepali;
  return order.itemName || '';
}

/**
 * Every name an item can be searched by. The search box has to match whichever
 * one the cashier types, not just the one currently on screen.
 */
export function searchableNames(item) {
  return [item?.name, item?.nameNepali].filter(Boolean).map((n) => n.toLowerCase());
}
